import React from 'react';

const badgeStyles = {
  base: 'se-inline-flex se-items-center se-rounded-full se-px-2.5 se-py-0.5 se-text-xs se-font-semibold',
  pending: 'se-bg-yellow-100 se-text-yellow-800',
  success: 'se-bg-green-100 se-text-green-800',
  critical: 'se-bg-red-100 se-text-red-800',
  new: 'se-bg-blue-100 se-text-blue-800',
  completed: 'se-bg-indigo-100 se-text-indigo-800',
  default: 'se-bg-gray-100 se-text-gray-800',
};

export default function Badge({ status, children }) {
  const getStyle = status => {
    switch (status) {
      case 'PENDING':
        return badgeStyles.pending;
      case 'ACCEPTED':
        return badgeStyles.success;
      case 'CANCELED':
        return badgeStyles.critical;
      case 'COUNTER_OFFERED':
        return badgeStyles.new;
      case 'COMPLETED':
        return badgeStyles.completed;
      default:
        return badgeStyles.default;
    }
  };

  return <span className={`${badgeStyles.base} ${getStyle(status)}`}>{children}</span>;
}
